itsoftApp.createModule("scrollAnimate", ["scrollEffects"], function () {
    /* Находим элементы, к которым нужно применять эффекты при скролле страницы */
    /* Передаём классы, которые требуется удалить/добавить, когда скролл дойдет до них */
    var ScrollEffects = itsoftApp.modules.scrollEffects.ScrollEffect,
        fadeInElements = document.querySelectorAll(".fadeIn"),
        elementsInvisible = document.querySelectorAll(".js-invisible");

        //анимация fadeIn элементов

    var initAnimation = function () {
        for (var i = 0; i < fadeInElements.length; i++) {
            new ScrollEffects(fadeInElements[i], "fadeIn--show");
        }

        for (var j = 0; j < elementsInvisible.length; j++) {
            new ScrollEffects(elementsInvisible[j], "js-visible", "js-invisible");
        }
    };

    itsoftApp.modules.pageLoad.addEvent(initAnimation);

});
